import { Box, Grid, IconButton, Tooltip } from "@mui/material";
import AccordianContainer from "../../../CustomComponents/AccordianContainer";
import CustomDataGrid from "../../../CustomComponents/CustomDataGrid";
import { CommonInformationDialogReduerAction } from "../../../Store/dialog/CommonInformationDialogReduer";
import { useDispatch } from "react-redux";
import { Visibility } from "@mui/icons-material";

const FoirDetails = ({ foirDetails }) => {

    const dispatch = useDispatch();

    const foirDetailsColumns = [
        {
            field: "foir",
            headerName: "Foir",
            headerAlign: "center",
            align: "center",
            flex: 200,
            type: "string",
            editable: false,
          },
            {
              field: "internalapplicationid",
              headerName: "Internal Application ID",
              headerAlign: "center",
              align: "center",
              flex: 200,
              type: "string",
              editable: false,
            },
            {
                field: "applicationnumber",
                headerName: "Application Number",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "assessedrole",
                headerName: "Assessed Role",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "otheremi",
                headerName: "Other EMI",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "monthlyemi",
                headerName: "Monthly EMI",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "affordableemi",
                headerName: "Affordable EMI",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "loanamount",
                headerName: "Loan Amount",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "remarks",
                headerName: "Remarks",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
                renderCell: (params) => {
                  return (
                    <Box
                      sx={{
                        justifyContent: "center",
                        display: "flex",
                        flex: 25,
                        
                      }}
                    >
                      <Tooltip title="View Remarks">
                        <IconButton
                          onClick={(e) => {
                            dispatch(CommonInformationDialogReduerAction.updateDialogHeader("Remarks"));
                            dispatch(CommonInformationDialogReduerAction.updateDialogText(params.row.remarks));
                            dispatch(CommonInformationDialogReduerAction.updateDialogOpen(true));
                          }}
                        >
                          <Visibility sx={{ color: "black" }} />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  );
                },
              }
    ];

    return(<>
         <AccordianContainer
          id="accord"
          title="Foir Details"
          initialOpen={false}
        >
          <Box sx={{ marginTop: "-0.5%" }}>
          <CustomDataGrid
            noDataMessage="No Data"
            rows={(foirDetails !== undefined && foirDetails !== null) ?
              foirDetails.map((item, index) => ({
                id: index + 1,
                ...item,
              })) : []}
            columns={foirDetailsColumns}
            pageSize={15}
            pageSizeOptions={[10]}
            gridLazyLoad={() => {}}
            gridHeight={305}
            getRowId={(row) => row.foir}
            onCellKeyDown={(event, param) => {
              (param.key === "e" || param.key === "E") &&
                param.preventDefault();
            }}
          />
          </Box>
          </AccordianContainer>
    </>);
}

export default FoirDetails;